import thickElement from "../../../images/silver-icon/thick-element.png";
import { IdSvrAuthService } from "../../auth/idSrvAuthService";
import { AgGridService } from "@topline/services/agGridService";
import { Gen } from "@topline/services/api";
import { MarketClient } from "@topline/services/apiService";
import { DateService } from "@topline/services/dateService";
import { FileDownloadService } from "@topline/services/fileDownloadService";
import { MarketCloneComponent } from "./components/marketCloneComponent";
import { MarketEditService } from "./services/marketEditService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ToasterService } from "@topline/services/toasterService";

(function (module) {
    "use strict";
    module.controller("marketListController", [
        "$scope",
        "$q",
        "modalService",
        IdSvrAuthService.componentName,
        "$state",
        MarketEditService.componentName,
        "AlertService",
        angularServicesNames.$uibModal,
        angularServicesNames.$translate,
        AgGridService.componentName,
        "initializeReportHubService",
        ToasterService.componentName,
        FileDownloadService.componentName,
        "marketFinishValidationService",
        "internationaMarketFileService",
        DateService.componentName,
        MarketClient.componentName,
        MarketListController
    ]);

    function MarketListController(
        this: $TSFixMe,
        $scope: $TSFixMe,
        $q: ng.IQService,
        modalService: $TSFixMe,
        authService: IdSvrAuthService,
        $state: ng.ui.IStateService,
        marketEditService: MarketEditService,
        AlertService: AlertService,
        $uibModal: ng.ui.bootstrap.IModalService,
        $translate: ng.translate.ITranslateService,
        agGridService: AgGridService,
        initializeReportHubService: $TSFixMe,
        toasterService: ToasterService,
        fileDownloadService: FileDownloadService,
        marketFinishValidationService: $TSFixMe,
        internationaMarketFileService: $TSFixMe,
        dateService: DateService,
        marketClient: MarketClient
    ) {
        var $ctrl = this;
        var exportIsFinished: $TSFixMe = null;
        var toast: $TSFixMe = null;

        $ctrl.finishingMarketsInProgress = false;

        const translationsResult = authService.hasPermissions(
            "ManageImsMarkets",
            "ManageFileMarkets",
            "ManageScoringCardsMarkets",
            "ManageScoringCardsPolandMarkets",
            "MarketExport",
            "SetMarketAsFinished",
            "ChangeMarketPM"
        );

        $scope.permissions = {
            canManageImsMarket: translationsResult["ManageImsMarkets"],
            canManageFileMarket: translationsResult["ManageFileMarkets"],
            canManageScoringCardsMarkets: translationsResult["ManageScoringCardsMarkets"],
            canManageScoringCardsPolandMarkets: translationsResult["ManageScoringCardsPolandMarkets"],
            canExportMarkets: translationsResult["MarketExport"],
            canFinishMarket: translationsResult["SetMarketAsFinished"],
            canChangeProductManager: translationsResult["ChangeMarketPM"]
        };

        $ctrl.filterInstance = {
            budgetYear: dateService.getDefaultBudgetYear()
        };

        $ctrl.budgetYearChanged = () => $ctrl.gridApi.onFilterChanged();

        $ctrl.createImsMarket = () => {
            marketEditService.create("ims").then(function (id: $TSFixMe) {
                $state.go("market.edit-ims", {
                    id
                });
            });
        };

        $ctrl.createFileMarket = () => {
            marketEditService.create("file").then(function (id: $TSFixMe) {
                $state.go("market.edit-file", {
                    id
                });
            });
        };

        $ctrl.createScoringCardsInternationalMarket = () => {
            marketEditService.create("scoringCards").then(function (id: $TSFixMe) {
                $state.go("market.edit-scoringcards", {
                    id
                });
            });
        };

        $ctrl.createScoringCardsPolandMarket = () => {
            marketEditService.create("scoringCardsPoland").then(function (id: $TSFixMe) {
                $state.go("market.edit-scoringcardspoland", {
                    id
                });
            });
        };

        $ctrl.isExportFinished = () => {
            if (exportIsFinished === null) {
                exportIsFinished = initializeReportHubService.getMarketContentReportGenerationIsFinished();
            }
            return exportIsFinished;
        };

        $scope.$on("LanguageChanged", () => agGridService.refreshGridLanguage($ctrl.gridApi));

        $scope.$on("market-content-report-generation-is-finished", () => {
            toasterService.clear(toast);
            AlertService.success($translate.instant("MARKET.MARKET_REPORT_GENERATED"));
            exportIsFinished = true;
        });

        $scope.$on("market-content-report-generation-is-started", () => {
            toast = toasterService.showReportGeneratingToast("MARKET.GENERATING_MARKET_REPORT");
            exportIsFinished = false;
        });

        $ctrl.marketGridOptions = {
            columnDefs: [
                {
                    headerValueGetter: () => $translate.instant("MARKET.LIST_GRID.NAME"),
                    checkboxSelection: true,
                    field: "name",
                    filter: "agTextColumnFilter",
                    filterParams: {
                        newRowsAction: "keep"
                    },
                    floatingFilterComponentParams: {
                        suppressFilterButton: true
                    },
                    minWidth: 470,
                    cellRenderer: (params: $TSFixMe) =>
                        params.data
                            ? `<a ui-sref="market.edit-${params.data.type.toLowerCase()}({id: ${params.data.id}})">${
                                  params.data.version != "" && params.data.version != null
                                      ? params.data.name + "-" + params.data.version
                                      : params.data.name
                              }</a>`
                            : null
                },
                {
                    headerValueGetter: () => $translate.instant("MARKET.LIST_GRID.PROJECT_MANAGER"),
                    field: "productManager",
                    filter: "agTextColumnFilter",
                    floatingFilterComponentParams: {
                        suppressFilterButton: true
                    },
                    suppressMenu: true,
                    cellRenderer: (params: $TSFixMe) => {
                        if (!params.data) return null;
                        const canChangeProductManager = $scope.permissions?.canChangeProductManager
                            ? "<a href='#' ng-click='$ctrl.changeProductOwner(data)'> <i class='glyphicon glyphicon-user'></i></a>"
                            : "";
                        return canChangeProductManager + params.data.productManager;
                    }
                },
                {
                    headerValueGetter: () => $translate.instant("MARKET.LIST_GRID.DESCRIPTION"),
                    field: "description",
                    filter: "agTextColumnFilter",
                    floatingFilterComponentParams: {
                        suppressFilterButton: true
                    }
                },
                {
                    headerValueGetter: () => $translate.instant("MARKET.LIST_GRID.TYPE"),
                    field: "type",
                    filter: "agSetColumnFilter",
                    valueFormatter: (params: $TSFixMe) => $translate.instant("DATA_SOURCES." + params.value),
                    filterParams: {
                        values: getValues(),
                        newRowsAction: "keep"
                    }
                },
                {
                    headerValueGetter: () => $translate.instant("MARKET.LIST_GRID.ACTIVE"),
                    field: "isActive",
                    filter: false,
                    cellRenderer: (params: $TSFixMe) =>
                        params.data && params.data.isActive
                            ? `<div class="ui-grid-cell-contents"><img src="${thickElement}"><div/>`
                            : null
                },
                {
                    headerValueGetter: () => $translate.instant("MARKET.LIST_GRID.BUDGET_YEAR"),
                    field: "budgetYear",
                    filter: false,
                    cellRenderer: (params: $TSFixMe) =>
                        params.data && params.data.budgetYear ? params.value : $translate.instant("NOT_APPLICABLE")
                },
                {
                    headerValueGetter: () => $translate.instant("MARKET.LIST_GRID.IS_FINISHED"),
                    field: "isFinished",
                    filter: false,
                    cellRenderer: (params: $TSFixMe) => {
                        if (!params.data) return null;

                        const isFinished =
                                params.data.isFinished && ["Ims", "ScoringCardsPoland"].includes(params.data.type)
                                    ? `<img src='${thickElement}'>`
                                    : "",
                            notApplicable = !["Ims", "ScoringCardsPoland"].includes(params.data.type)
                                ? "<span>{{'NOT_APPLICABLE' | translate}}</span>"
                                : "";

                        return "<div class='ui-grid-cell-contents'>" + isFinished + notApplicable + "<div/>";
                    }
                },
                {
                    headerValueGetter: () => $translate.instant("ACTIONS"),
                    cellRenderer: (params: $TSFixMe) => {
                        if (!params.data) return null;

                        const removeTooltipText = $translate.instant("TOOLTIP.REMOVE"),
                            isActiveTooltipText = !params.data.isActive
                                ? $translate.instant("MARKET.ACTIVATE")
                                : $translate.instant("MARKET.DEACTIVATE"),
                            isFinishedClass = params.data.isFinished ? "fas fa-lock-open" : "fas fa-lock",
                            isFinishedTooltip = params.data.isFinished
                                ? $translate.instant("MARKET.REVERT_FINISH")
                                : $translate.instant("MARKET.FINISH"),
                            classActive = params.data.isActive ? "glyphicon-ban-circle" : "glyphicon-ok-circle",
                            isEditable = params.data.editabilityInfo.isEditable
                                ? "<a href='#' ng-if='!data.finishInProgress' data-toggle='tooltip' ng-click='$ctrl.remove(data)' data-placement='top' title='" +
                                  removeTooltipText +
                                  "'><i class='glyphicon glyphicon-trash'></i></a>"
                                : "",
                            isCloneable = params.data.editabilityInfo.isCloneable
                                ? "<a href='#' ng-if='!data.finishInProgress' ng-click='$ctrl.copyMarket(data)' data-toggle='tooltip' data-placement='top' title='{{ \"MARKET.COPY\" | translate }}'><i class='glyphicon glyphicon-copy'></i></a>"
                                : "",
                            isActivable = params.data.editabilityInfo.isActivable
                                ? "<a href='#' ng-if='!data.finishInProgress' ng-click='$ctrl.toggleActivity(data)'  data-toggle='tooltip' data-placement='top' title='" +
                                  isActiveTooltipText +
                                  "'> " +
                                  "<i class='glyphicon " +
                                  classActive +
                                  "'></i>" +
                                  "</a>"
                                : "",
                            finishMarket =
                                $scope.permissions?.canFinishMarket &&
                                ["Ims", "ScoringCardsPoland"].includes(params.data.type) &&
                                params.data.isActive
                                    ? "<a href='#' ng-if='!data.finishInProgress' ng-click='$ctrl.finishMarket(data)'>" +
                                      "<i class='" +
                                      isFinishedClass +
                                      "' title='" +
                                      isFinishedTooltip +
                                      "'></i>" +
                                      "</a>"
                                    : "",
                            finishInProgress =
                                "<a href='#'><i ng-if='data.finishInProgress' class='fas fa-redo-alt fa-spin'><i/></a>";

                        return (
                            "<div class='ui-grid-cell-contents'>" +
                            isEditable +
                            isCloneable +
                            isActivable +
                            finishMarket +
                            finishInProgress +
                            "</div>"
                        );
                    },
                    filter: false,
                    sortable: false,
                    suppressMenu: true
                }
            ],
            floatingFilter: true,
            angularCompileRows: true,
            defaultColDef: {
                sortable: true,
                resizable: true,
                filterParams: {
                    newRowsAction: "keep"
                }
            },
            animateRows: true,
            pagination: true,
            rowModelType: "serverSide",
            rowGroupPanelShow: "never",
            suppressMultiSort: true,
            domLayout: "autoHeight",
            popupParent: document.getElementById("marketGrid"),
            localeTextFunc: agGridService.transalteFunc,
            suppressHorizontalScroll: true,
            rowSelection: "multiple",
            suppressRowClickSelection: true,
            isRowSelectable: (rowNode: $TSFixMe) =>
                rowNode.data && ["Ims", "ScoringCardsPoland"].includes(rowNode.data.type),
            onGridReady: (config: $TSFixMe) => {
                $ctrl.gridApi = config.api;
                config.api.setServerSideDatasource(
                    agGridService.createDataSource(
                        (options: Gen.MarketGridQuery) => marketClient.getMarketGrid(options),
                        $ctrl.filterInstance
                    )
                );
                config.api.sizeColumnsToFit();
            },
            onGridSizeChanged: (config: $TSFixMe) => {
                config.api.sizeColumnsToFit();
            }
        };

        $ctrl.showNoFileMarketsMessage = () =>
            modalService.showConfirmationModal(
                {
                    text: "MARKET.NO_FILE_MARKETS",
                    title: "MARKET.NO_FILE_MARKETS_TITLE",
                    okText: "OK"
                },
                null,
                null,
                "warning"
            );

        $ctrl.reloadPageSize = (value: $TSFixMe) => {
            if ($ctrl.marketGridOptions.api) {
                $ctrl.marketGridOptions.api.paginationSetPageSize(value);
            }
        };

        function getValues() {
            var values = [];
            if ($scope.permissions?.canManageImsMarket) {
                values.push("Ims");
            }
            if ($scope.permissions?.canManageFileMarket) {
                values.push("File");
            }
            if ($scope.permissions?.canManageScoringCardsMarkets) {
                values.push("ScoringCards");
            }
            if ($scope.permissions?.canManageScoringCardsPolandMarkets) {
                values.push("ScoringCardsPoland");
            }
            return values;
        }

        $ctrl.toggleActivity = (entity: $TSFixMe) => {
            marketEditService.toggleActivity(entity.id).then(() => getPage());
        };

        $ctrl.finishMarket = function (market: $TSFixMe) {
            if (!market.budgetYear) {
                AlertService.error($translate.instant("MARKET.BUDGET_YEAR_IS_REQUIRED"));
                return;
            }

            if (market.isFinished || (market.type != "Ims" && market.type != "ScoringCardsPoland")) {
                $ctrl.toggleMarketFinished(market);
                return;
            }

            market.finishInProgress = true;

            if (market.type == "Ims" || market.type == "ScoringCardsPoland") {
                marketEditService.checkMarketMetsRequirements(market.id).then((satisfiesMarketType: $TSFixMe) => {
                    if (!satisfiesMarketType) {
                        market.finishInProgress = false;
                        AlertService.error($translate.instant("MARKET.FINISH_MARKET_TYPE_REQUIREMENT_ERROR"));
                    } else {
                        $ctrl.toggleMarketFinishedNoConfirmation(market);
                    }
                });
            }
        };

        $ctrl.toggleMarketFinishedNoConfirmation = function (market: $TSFixMe) {
            marketEditService
                .toggleMarketFinished(market.id, !market.isFinished)
                .then(response => {
                    const defer = $q.defer();
                    market.finishInProgress = false;
                    if (response.status == HttpStatus.OK || response.status == 204) {
                        return defer.resolve();
                    } else {
                        marketEditService.displaySaveMarketError(response, market);
                        return defer.reject();
                    }
                })
                .then(() => getPage());
        };

        $ctrl.toggleMarketFinished = function (market: $TSFixMe) {
            if (!market.budgetYear) {
                AlertService.error($translate.instant("MARKET.BUDGET_YEAR_IS_REQUIRED"));
                return;
            }

            let confirmQuestionName = !market.isFinished
                ? "MARKET.SET_MARKET_FINISHED_STATUS_CONFIRM"
                : "MARKET.REMOVE_MARKET_FINISHED_STATUS_CONFIRM";
            let confirmQuestionNameTitle = !market.isFinished
                ? "MARKET.SET_MARKET_FINISHED_STATUS_CONFIRM_TITLE"
                : "MARKET.REMOVE_MARKET_FINISHED_STATUS_CONFIRM_TITLE";

            modalService.showConfirmationModal(
                {
                    text: confirmQuestionName,
                    title: confirmQuestionNameTitle
                },
                () => {
                    marketEditService
                        .toggleMarketFinished(market.id, !market.isFinished)
                        .then(response => {
                            const defer = $q.defer();
                            if (response.status == HttpStatus.OK || response.status == 204) {
                                return defer.resolve();
                            } else {
                                marketEditService.displaySaveMarketError(response, market);
                                return defer.reject();
                            }
                        })
                        .then(() => getPage());
                }
            );
        };

        $ctrl.remove = (entity: $TSFixMe) => {
            if (!entity) {
                return;
            }

            modalService.showConfirmationModal(
                {
                    text: "MARKET.REMOVE_CONFIRM",
                    title: "MARKET.REMOVE_CONFIRM_TITLE"
                },
                () => {
                    marketEditService
                        .delete(entity.id)
                        .then(() => AlertService.success($translate.instant("MARKET.REMOVE_SUCCESS")))
                        .catch(() => AlertService.error($translate.instant("MARKET.REMOVE_ERROR")))
                        .then(() => getPage());
                },
                null,
                "danger"
            );
        };

        $ctrl.copyMarket = (entity: $TSFixMe) => {
            const budgetYear = angular.isNumber(entity.budgetYear) ? parseInt(entity.budgetYear) + 1 : null;

            var modalInstance = $uibModal.open({
                component: MarketCloneComponent.componentName,
                resolve: {
                    marketId: () => entity.id,
                    name: () => entity.name,
                    version: () => entity.version,
                    budgetYear: () => budgetYear,
                    type: () => entity.type
                }
            });

            modalInstance.result.then(function (result: $TSFixMe) {
                $scope.serverOperation = marketEditService.clone(entity.id, result).then(() => getPage());
            });
        };

        function getPage() {
            $ctrl.gridApi.onFilterChanged();
        }

        $ctrl.exportMarkets = function () {
            var modalInstance = $uibModal.open({
                component: "marketExport",
                size: "special"
            });
            modalInstance.result.then(
                () => {},
                () => {}
            );
        };

        $ctrl.changeProductOwner = (entity: $TSFixMe) => {
            const modalInstance = $uibModal.open({
                component: "changeProductManager",
                resolve: {
                    productManagerMsnuId: () => entity.productManagerMsnuId,
                    name: () => entity.name
                }
            });
            modalInstance.result.then(
                (productManager: $TSFixMe) => {
                    $scope.serverOperation = marketEditService
                        .changeProductManager(entity.id, productManager.msnuId)
                        .then(() => getPage());
                },
                () => {}
            );
        };

        $ctrl.finishSelectedMarkets = () => {
            var markets = $ctrl.gridApi.getSelectedRows();

            if (markets.length === 0) return;

            $ctrl.finishingMarketsInProgress = true;
            marketFinishValidationService
                .validateAndFinish(markets)
                .catch(() => {
                    $ctrl.finishingMarketsInProgress = true;
                })
                .then(() => {
                    $ctrl.finishingMarketsInProgress = false;
                    getPage();
                });
        };

        $ctrl.unfinishSelectedMarkets = () => {
            const markets = _.filter($ctrl.gridApi.getSelectedRows(), (m: $TSFixMe) => m.isFinished);
            if (markets.length > 0) {
                modalService.showConfirmationModal(
                    {
                        text: "MARKET.REMOVE_MARKETS_FINISHED_STATUS_CONFIRM",
                        title: "MARKET.REMOVE_MARKETS_FINISHED_STATUS_CONFIRM_TITLE"
                    },
                    () => {
                        marketEditService.toogleMarketsFinished(markets, status).then(() => getPage());
                    }
                );
            } else {
                AlertService.warning($translate.instant("MARKET.NO_SELECTED_MARKETS_MEET_CRITERIA"));
            }
        };

        $ctrl.generateMarketTemplate = async () => {
            const { recentDataFetchOptions } = $ctrl.gridApi.getModel().datasource;

            if (recentDataFetchOptions.totalCount === 0) {
                $ctrl.showNoFileMarketsMessage();
                return;
            }

            const fetchAllDataOptions = Object.assign({}, recentDataFetchOptions, {
                pageSize: recentDataFetchOptions.totalCount
            });

            $ctrl.generatingDataFileTemplateInProgress = true;

            const { items } = await marketClient.getMarketGrid(fetchAllDataOptions);
            const allFileMarkets = items.filter(m => m.type === "File" && m.historicalVolumeDataSource === Gen.HistoricalVolumeDataSourceType.File);

            if (allFileMarkets.length === 0) {
                $ctrl.showNoFileMarketsMessage();
                $ctrl.generatingDataFileTemplateInProgress = false;
                return;
            }

            toasterService.showReportGenerateBusyIndicator(
                () =>
                    fileDownloadService.downloadFilePost(
                        "/api/market/file/template/market-volume",
                        "MarketVolume.xlsx",
                        {
                            markets: allFileMarkets.map(a => ({
                                marketId: a.id,
                                marketName: a.name,
                                historicalVolumeDataSource: a.historicalVolumeDataSource,
                            }))
                        }
                    ),
                "MARKET.GENERATE_TEMPLATE",
                "MARKET.TEMPLATE_GENERATED"
            );

            $ctrl.generatingDataFileTemplateInProgress = false;
        };

        $ctrl.generateSkuMarketTemplate = async () => {
            const { recentDataFetchOptions } = $ctrl.gridApi.getModel().datasource;

            if (recentDataFetchOptions.totalCount === 0) {
                $ctrl.showNoFileMarketsMessage();
                return;
            }

            const fetchAllDataOptions = Object.assign({}, recentDataFetchOptions, {
                pageSize: recentDataFetchOptions.totalCount
            });

            $ctrl.generatingSkuDataFileTemplateInProgress = true;

            const { items } = await marketClient.getMarketGrid(fetchAllDataOptions);

            const allFileMarkets = items.filter(m => m.type === "File" && m.skuHistoricalVolumeDataSource === Gen.SkuHistoricalVolumeDataSourceType.File);

            if (allFileMarkets.length === 0) {
                $ctrl.showNoFileMarketsMessage();
                $ctrl.generatingSkuDataFileTemplateInProgress = false;
                return;
            }

            const fileMarketsIds = allFileMarkets.map(a => a.id);

            const skusInMarkets = await marketEditService.getSkusInMarkets(fileMarketsIds);

            const markets = allFileMarkets.map(fm => ({
                marketId: fm.id,
                marketName: fm.name,
                skus: skusInMarkets[fm.id],
                skuHistoricalVolumeDataSource : fm.skuHistoricalVolumeDataSource
            }));

            toasterService.showReportGenerateBusyIndicator(
                () =>
                    fileDownloadService.downloadFilePost(
                        "/api/market/file/template/skus-volume",
                        "MarketSkusVolume.xlsx",
                        {
                            markets
                        }
                    ),
                "MARKET.GENERATE_TEMPLATE",
                "MARKET.TEMPLATE_GENERATED"
            );

            $ctrl.generatingSkuDataFileTemplateInProgress = false;
        };

        $ctrl.uploadMarketFile = async (file: $TSFixMe) => {
            if (!file) return;

            $ctrl.importingDataFileInProgress = true;

            try {
                await internationaMarketFileService.uploadMarketFile({ file });
            } catch (e) {
            } finally {
                $ctrl.importingDataFileInProgress = false;
            }
        };

        $ctrl.uploadSkuMarketFile = async (file: $TSFixMe) => {
            if (!file) return;

            $ctrl.importingSkuDataFileTemplateInProgress = true;

            try {
                await internationaMarketFileService.uploadSkuFile({ file });
            } catch (e) {
            } finally {
                $ctrl.importingSkuDataFileTemplateInProgress = false;
            }
        };
    }
})(angular.module("topline.modules"));
